<template>
  <section>
    <div class="card">
      <div class="card-inner">
        <p class="card-title"> Défi(s) terminé(s)</p>
        <div
          v-if="finished_challenges.length > 0 && !isAdmin"
          style="text-align: center"
        >
          <div
            v-for="(chall, index) in  finished_challenges"
            class="challenge-container"
            :key="index"
          >
            <div class="versus-block">
              <span><strong>{{getWeezyName(chall.weezy1_id)}}</strong></span> VS <span><strong>{{getWeezyName(chall.weezy2_id)}}</strong></span>
            </div>
            <div>
              <div id="myProgress">
                <div
                  id="myBar"
                  :style="'width:' + chall.percent_1/2 + '%'"
                ><span style="color: white">{{chall.percent_1}}%</span></div>
                <div
                  id="mySecondBar"
                  :style="'width:' + chall.percent_2/2 + '%'"
                ><span style="color: white">{{chall.percent_2}}%</span></div>
              </div>
            </div>
            <div
              class="challenge-result"
              v-if="chall.percent_1 > 0 || chall.percent_2 > 0"
            >
              <span v-if="chall.percent_1 > chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy1_id)}}</strong> à remporté ce défi !</span>
              <span v-else-if="chall.percent_1 < chall.percent_2">L'équipe <strong>{{getWeezyName(chall.weezy2_id)}}</strong> à remporté ce défi !</span>
              <span v-else>Les deux équipes ont fini ex-æquo!</span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="no-waiting"
        >
          Aucun défi terminé
        </div>

        <div style="margin-left: 25px; margin-right: 25px; margin-top: 25px; ">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import http from "@/modules/request";

export default {
  name: "finishedChallenges",
  props: ["finished_challenges", "weezys", "isAdmin"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: false
    };
  },
  methods: {
    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    },
    errorToast(message) {
      this.$parent.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$parent.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>